import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Eyebrow } from "@/components/ui-custom/Eyebrow";
import { TESTIMONIALS } from "@/data/site";

const initials = (name) =>
  name
    .replace(/[^a-zA-Z ]/g, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const Card = ({ t }) => (
  <div
    className="p-7"
    style={{
      borderRadius: 16,
      background: "var(--charcoal)",
      border: "1px solid var(--border-dark)",
      maxWidth: 340,
    }}
  >
    <div className="flex gap-1 mb-4">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} size={15} strokeWidth={1.5} style={{ color: "var(--cta)", fill: "var(--cta)" }} />
      ))}
    </div>
    <p style={{ color: "rgba(245,242,236,0.82)", fontSize: "15px", lineHeight: 1.6 }}>“{t.quote}”</p>
    <div className="flex items-center gap-3 mt-6">
      <span
        className="flex items-center justify-center shrink-0"
        style={{ width: 42, height: 42, borderRadius: 999, background: "var(--cta-gradient)", color: "#17130a", fontWeight: 700, fontSize: 14, fontFamily: "Inter" }}
      >
        {initials(t.name)}
      </span>
      <div>
        <div style={{ color: "var(--text-light)", fontWeight: 600, fontSize: 15 }}>{t.name}</div>
        <div style={{ color: "rgba(245,242,236,0.5)", fontSize: 13 }}>{t.role} · {t.town}</div>
      </div>
    </div>
  </div>
);

const Column = ({ items, duration, className = "" }) => (
  <div className={className}>
    <motion.div
      animate={{ translateY: "-50%" }}
      transition={{ duration, repeat: Infinity, ease: "linear", repeatType: "loop" }}
      className="flex flex-col gap-6 pb-6"
    >
      {[...items, ...items].map((t, i) => (
        <Card key={i} t={t} />
      ))}
    </motion.div>
  </div>
);

export const TestimonialsWall = () => {
  const col1 = TESTIMONIALS.slice(0, 3);
  const col2 = TESTIMONIALS.slice(3, 6);
  const col3 = TESTIMONIALS.slice(6, 9);

  return (
    <section className="sec-black section-y" data-testid="home-testimonials" style={{ position: "relative", overflow: "hidden" }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(60% 50% at 50% 0%, rgba(245,207,112,0.07) 0%, rgba(0,0,0,0) 60%)",
          pointerEvents: "none",
        }}
      />
      <div className="container-1200 relative">
        <div className="flex flex-col items-center text-center max-w-xl mx-auto">
          <Eyebrow>Kind Words</Eyebrow>
          <h2 className="h2 mt-5" style={{ color: "var(--text-light)" }}>What Your Neighbors Say</h2>
          <p className="mt-4" style={{ color: "rgba(245,242,236,0.6)", fontSize: 16 }}>
            Real homeowners and business owners across Central New Jersey — in their own words.
          </p>
        </div>

        <div
          className="flex justify-center gap-6 mt-14"
          style={{
            maxHeight: 620,
            overflow: "hidden",
            WebkitMaskImage:
              "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
            maskImage:
              "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
          }}
        >
          <Column items={col1} duration={22} />
          <Column items={col2} duration={28} className="hidden md:block" />
          <Column items={col3} duration={25} className="hidden lg:block" />
        </div>
      </div>
    </section>
  );
};
